import React, { useEffect, useState } from 'react';
import ResourceTabs from '../common/ResourceTabs';
import Filter from '../common/tables/Filter';
import { Button, Icon, Toolbar, ToolbarItem } from '../common';
import { Searchbar } from '../common/components/Searchbar';
import CheckboxFilter from '../common/tables/CheckboxFilter';
import { PortOpeningRequestsDirection } from '../../models/enums/POR/PortOpeningRequestsDirection';
import { AWSPortOpeningRequestsTypes } from '../../models/enums/POR/AWSPortOpeningRequestType';
import { DoNotDecryptRequestsDirection } from '../../models/enums/DNDR/DoNotDecryptRequestsDirection';
import moment from 'moment';

interface Dictionary {
	[Key: string]: any;
}

interface ApprovalsHomeFiltersProps {
	setActiveTab: Function;
	activeTab: string;
	retrieveApprovals: any;
	listsDictionary: Dictionary;
	setFilteredAccounts: Function;
	setFilteredEnterpriseApps: Function;
	setFilteredPORs: Function;
	setFilteredDPIs: Function;
	setFilteredTAPs: Function;
	setFilteredAWSPORs: Function;
	setFilteredOnPremPORs: Function;
	namesDictionary: Dictionary;
}

const ApprovalsHomeFilters = ({
	setActiveTab,
	activeTab,
	listsDictionary,
	setFilteredAccounts,
	setFilteredEnterpriseApps,
	setFilteredPORs,
	setFilteredDPIs,
	setFilteredTAPs,
	setFilteredAWSPORs,
	setFilteredOnPremPORs,
	namesDictionary,
	retrieveApprovals,
}: ApprovalsHomeFiltersProps) => {
	const resourceTabs = [];
	resourceTabs.push({
		item1: namesDictionary.accounts,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.apps,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.pors,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.dpis,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.taps,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.awspors,
		item2: null,
	});
	resourceTabs.push({
		item1: namesDictionary.onprempors,
		item2: null,
	});
	const defaultFilters = {
		searchGeneral: '',
		showResources: namesDictionary[activeTab],
		porType: [
			{ label: PortOpeningRequestsDirection.SubscriptionToOnPrem.displayName, value: PortOpeningRequestsDirection.SubscriptionToOnPrem.name, checked: true },
			{ label: PortOpeningRequestsDirection.SubscriptionToInternet.displayName, value: PortOpeningRequestsDirection.SubscriptionToInternet.name, checked: true },
			{ label: PortOpeningRequestsDirection.SubscriptionToSubscription.displayName, value: PortOpeningRequestsDirection.SubscriptionToSubscription.name, checked: true },
		],
		awsPorType: [
			{ label: AWSPortOpeningRequestsTypes.AccountToInternet.displayName, value: AWSPortOpeningRequestsTypes.AccountToInternet.name, checked: true },
			//{ label: AWSPortOpeningRequestsTypes.AccountToDMZ.displayName, value: AWSPortOpeningRequestsTypes.AccountToDMZ.name, checked: true },
			//{ label: AWSPortOpeningRequestsTypes.Untrusted.displayName, value: AWSPortOpeningRequestsTypes.Untrusted.name, checked: true },
		],
		onPremPorType: [
			{ label: PortOpeningRequestsDirection.DomainToConnection.displayName, value: PortOpeningRequestsDirection.DomainToConnection.name, checked: true },
			{ label: PortOpeningRequestsDirection.DomainToInternet.displayName, value: PortOpeningRequestsDirection.DomainToInternet.name, checked: true },
			{ label: PortOpeningRequestsDirection.DomainProxyToInternet.displayName, value: PortOpeningRequestsDirection.DomainProxyToInternet.name, checked: true }
		],
		dpiType: [
			{ label: DoNotDecryptRequestsDirection.SubscriptionToInternet.displayName, value: DoNotDecryptRequestsDirection.SubscriptionToInternet.name, checked: true },
			{ label: DoNotDecryptRequestsDirection.SubscriptionToOnPrem.displayName, value: DoNotDecryptRequestsDirection.SubscriptionToOnPrem.name, checked: true },
			//{ label: DoNotDecryptRequestsDirection.OnPremToInternet.displayName, value: DoNotDecryptRequestsDirection.OnPremToInternet.name, checked: true },
			//{ label: DoNotDecryptRequestsDirection.NECTUpdate.displayName, value: DoNotDecryptRequestsDirection.NECTUpdate.name, checked: true },
		]
	};

	const filterApprovals = () => {
		const filterCallback = (element: any) => {
			return (
				filter.filterSearchText('searchGeneral', element.createdUserPrincipalName) || // For Cloud Accounts
				filter.filterSearchText('searchGeneral', element.displayName) || // For TAPs
				filter.filterSearchText('searchGeneral', element.subscriptionRequestName) || // For POR and DNDR
				filter.filterSearchText('searchGeneral', element.requestor?.displayName) || // For TAPs
				filter.filterSearchText('searchGeneral', element.owner?.displayName) ||  // For Entra ID Apps
				filter.filterSearchText('searchGeneral', element.newOwner?.displayName) || // For Entra ID Apps
				filter.filterSearchText('searchGeneral', element.direction?.name) || // For OnPrem POR Added by Kenny
				filter.filterSearchText('searchGeneral', element.accountName) // For AWS POR Added by Kenny
			);
		};
		let filtered = [];
		switch (filter.filters.showResources) {
			case 'Cloud Accounts':
				setActiveTab('accounts');
				filtered = listsDictionary.accounts.filter(filterCallback);
				filtered.sort((a, b) => {
					return (
						moment(b.workflowInstance.createdDate).valueOf() -
						moment(a.workflowInstance.createdDate).valueOf()
					);
				});
				setFilteredAccounts(filtered);
				break;
			case 'Entra ID Apps':
				setActiveTab('apps');
				filtered = listsDictionary.apps.filter(filterCallback);
				setFilteredEnterpriseApps(filtered);
				break;
			case 'PORs':
				setActiveTab('pors');
				filtered = listsDictionary.pors
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('porType', element.direction?.name));
				setFilteredPORs(filtered);
				break;
			case 'DPIs':
				setActiveTab('dpis');
				filtered = listsDictionary.dpis
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('dpiType', element.direction?.name));
				setFilteredDPIs(filtered);
				break;
			case 'TAPs':
				setActiveTab('taps');
				filtered = listsDictionary.taps.filter(filterCallback);
				setFilteredTAPs(filtered);
				break;
			case 'AWS PORs':
				setActiveTab('awspors');
				filtered = listsDictionary.awspors
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('awsPorType', element.type?.name));
				setFilteredAWSPORs(filtered);
				break;
			case 'On-Prem PORs':
				setActiveTab('onprempors');
				filtered = listsDictionary.onprempors
					.filter(filterCallback)
					.filter((element: any) => filter.filterCheckBox('onPremPorType', element.direction?.name));
				setFilteredOnPremPORs(filtered);
				break;
		}
	};
	useEffect(() => {
		filter.filter();
	}, []);

	useEffect(() => {
		filter.updateFilterFunction(filterApprovals);
	}, [listsDictionary]);
	const clearSearchbar = (e) => {
		e.preventDefault();
		filter.updateFilter('', 'searchGeneral');
	};

	const handleRefresh = () => {
		filter.updateFilter('My Approvals', 'Show Resources');
		retrieveApprovals(true);
	};

	const [filter, setFilter] = useState<Filter<any>>(new Filter(filterApprovals, defaultFilters));
	return (
		<>
			<ResourceTabs allResources={resourceTabs} filter={filter} />
			<Toolbar id="toggle-toolbar">
				<ToolbarItem width='lg'>
					<Searchbar
						condensed
						onClick={clearSearchbar}
						value={filter.filters.searchGeneral}
						onChange={(e) => filter.handleSearchTextChange(e, 'searchGeneral')}
						placeholder={'Search'}
					/>
				</ToolbarItem>
				{activeTab === 'dpis' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Type"
							onChange={(event) => filter.handleCheckboxChange(event, 'dpiType')}
							options={filter.filters.dpiType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				{activeTab === 'pors' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Type"
							onChange={(event) => filter.handleCheckboxChange(event, 'porType')}
							options={filter.filters.porType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				{activeTab === 'awspors' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Type"
							onChange={(event) => filter.handleCheckboxChange(event, 'awsPorType')}
							options={filter.filters.awsPorType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				{activeTab === 'onprempors' && (
					<ToolbarItem>
						<CheckboxFilter
							label="Scope"
							onChange={(event) => filter.handleCheckboxChange(event, 'onPremPorType')}
							options={filter.filters.onPremPorType}
							allDefaultChecked={true}
						/>
					</ToolbarItem>
				)}
				<ToolbarItem>
					<Button size='small' variant="secondary" onClick={handleRefresh}>
						<Icon icon="refresh" size="small" />
						<span> Refresh</span>
					</Button>
				</ToolbarItem>
			</Toolbar>
		</>
	);
};

export default ApprovalsHomeFilters;
